import { NumberOfTries, NumberOfTriesAction } from "../types/types"

export const numberOfTriesReducer = (
  numberOfTries: NumberOfTries,
  action: NumberOfTriesAction
) => {
  switch (action.type) {
    case "INCREMENT": {
      console.log(action.type)
      return { count: numberOfTries.count + 1, timestamp: Date.now() }
    }
    case "RESET": {
      return { count: 0, timestamp: Date.now() }
    }
    default:
      return numberOfTries
  }
}
